import React, { PropTypes } from 'react';
import classnames from 'classnames';

const Story = ({ title, content_html, image, background, showImageAbove, showImageCentered }) => {
  let img = null;

  if (image && image.url) {
    img = (
      <div className={classnames("image-wrapper", {
        "text-center": showImageCentered,
        "above-content": showImageAbove
      })}>
        <img src={image.url} alt={image.alt} />
      </div>
    );
  }

  return (
    <section className={classnames("block block-story", background)}>
      <div className="row columns">
        <div className="block-header">
          <h2>{ title }</h2>
        </div>
      </div>
      <div className="row">
        <div className="small-16 medium-12 medium-offset-2 large-10 large-offset-3 columns">
          { showImageAbove && img }
          <div className="content" dangerouslySetInnerHTML={{ __html: content_html }} />
          { !showImageAbove && img }
        </div>
      </div>
    </section>
  );
};

Story.propTypes = {
  title: PropTypes.string,
  content_html: PropTypes.string,
  image: PropTypes.object,
  background: PropTypes.string,
  showImageAbove: PropTypes.bool,
  showImageCentered: PropTypes.bool,
};

export default Story;



// WEBPACK FOOTER //
// ./landing_pages/components/story.jsx